<template>
  <div id="root">
    <div class="backgrid">
      <vue-draggable-resizable :grid=[20,20]>
        <v-chart class="chart" :option="option" />
      </vue-draggable-resizable>
    </div>
  </div>
</template>

<script>
  import { use } from "echarts/core";
  import { CanvasRenderer } from "echarts/renderers";
  import { PieChart } from "echarts/charts";
  import { BarChart } from "echarts/charts";

  import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent
  } from "echarts/components";

  import VChart, { THEME_KEY } from "vue-echarts";

  use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    PieChart,
    BarChart,
  ]);

  export default {
    name: "echartsTest",
    components: {
      VChart
    },
    provide: {
      [THEME_KEY]: "dark"
    },
    data() {
      return {
        //////////////
        option: {
          title: {
            text: "drag echart test",
            left: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            left: "left",
            data: [
              "Direct",
              "Email",
              "Ad Networks",
              "Video Ads",
              "Search Engines"
            ]
          },
          series: [

            {
              name: "Traffic Sources",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: [
                { value: 335, name: "Direct" },
                { value: 310, name: "Email" },
                { value: 234, name: "Ad Networks" },
                { value: 135, name: "Video Ads" },
                { value: 1548, name: "Search Engines" }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        }


        //////////////
      };


    }
  };
</script>

<style scoped>
  html,
  body,
  #root,
  #root>div {
    height: 1000px;
    top: 0;
    bottom: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: Arial;
  
  }

  .backgrid {
    position: relative;
    background: linear-gradient(-90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px) repeat scroll 0% 0% / 20px 20px, rgba(0, 0, 0, 0) linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px) repeat scroll 0% 0% / 20px 20px;
  }

  .chart {
    height: 400px;
    width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/echartsTest.vue